module.exports = __webpack_public_path__ + "res/down_arrow.png";